/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Chunk_LostInputs */



/**
* | output |
* | --- |
* | "A piece of the recording did not come through. The rest keeps recording." |
*
* @param {Meeting_Offline_Chunk_LostInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_chunk_lost = /** @type {((inputs?: Meeting_Offline_Chunk_LostInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Chunk_LostInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een stuk van de opname is niet doorgekomen. De rest neemt gewoon verder op.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un morceau de l'enregistrement n'est pas arrivé. Le reste continue d'être enregistré.")
	return /** @type {LocalizedString} */ ("A piece of the recording did not come through. The rest keeps recording.")
});